<template>
 <div></div>
</template>

<script>
export default {
  data() {
      return {}
  }
};
</script>

<style lang="stylus" scoped>
.tabs {
  background: #fff;
  border-bottom: 1px solid #eee;

  .el-tag {
    margin-right: 16px;
    cursor: pointer;
  }
}
</style>